
module.exports = {
  "border": {
    "radius": {
      "default": "4px"
    }
  },
  "breakpoints": {
    "xxsMax": "374px",
    "xs": "375px",
    "xsMax": "479px",
    "sm": "480px",
    "smMax": "667px",
    "md": "668px",
    "mdMax": "991px",
    "lg": "992px",
    "lgMax": "1199px",
    "xl": "1200px"
  },
  "colors": {
    "palette": {
      "white": "#fff",
      "black": "#000",
      "gray": {
        "20": "#333",
        "40": "#666",
        "53": "#888",
        "84": "#d6d6d6",
        "91": "#e7e7e7",
        "97": "#f7f7f7",
        "lightest": "#f7f7f7",
        "light": "#d6d6d6",
        "medium": "#888",
        "dark": "#666",
        "darkest": "#333"
      },
      "red": {
        "24": "#790000",
        "33": "#a00",
        "40": "#c00",
        "default": "#c00",
        "dark": "#a00"
      },
      "orange": {
        "36": "#b85300",
        "45": "#E86900",
        "default": "#E86900",
        "dark": "#b85300",
        "light": "#FFF5EB"
      },
      "green": {
        "13": "#004201",
        "20": "#006601",
        "26": "#008300",
        "32": "#00A200",
        "37": "#568B30",
        "light": "#00A200",
        "default": "#008300",
        "dark": "#006601",
        "darker": "#004201"
      },
      "blue": {
        "53": "#366Cd9",
        "default": "#366Cd9"
      },
      "yellow": {
        "52": "#Fde30b",
        "default": "#Fde30b"
      },
      "taupe": {
        "73": "#ead18b"
      },
      "gold": {
        "67": "#f7da5e"
      },
      "ivory": {
        "84": "#ffe0ae"
      },
      "olive": {
        "66": "#d7e26d"
      },
      "teal": {
        "76": "#a7dbd8"
      },
      "coral": {
        "72": "#f99178"
      }
    },
    "background": {
      "default": "#fff",
      "lightest": "#f7f7f7",
      "darkest": "#333",
      "ribbon": "#fff",
      "disabled": "#f7f7f7",
      "warning": "#FFF5EB"
    },
    "text": {
      "formLabel": "#666",
      "onLight": {
        "primary": "#333",
        "secondary": "#666"
      },
      "onDark": {
        "primary": "#fff"
      }
    },
    "iconFill": {
      "onLight": "#888"
    },
    "link": {
      "onLight": {
        "default": "#666",
        "hover": "#333",
        "focus": "#333"
      },
      "onLightSecondary": {
        "default": "#333",
        "hover": "#000"
      },
      "onDark": {
        "default": "#fff",
        "hover": "#d6d6d6"
      },
      "promotion": {
        "default": "#c00",
        "hover": "#a00"
      },
      "success": {
        "default": "#008300",
        "hover": "#00A200"
      },
      "warning": {
        "default": "#E86900",
        "hover": "#b85300"
      }
    },
    "interactive": {
      "primary": {
        "default": "#c00",
        "hover": "#a00",
        "active": "#790000"
      },
      "secondary": {
        "default": "#fff",
        "hover": "#f7f7f7",
        "active": "#333"
      },
      "disabled": {
        "default": "#d6d6d6"
      },
      "native": {
        "flatButton": "#366Cd9"
      }
    },
    "border": {
      "focusOutline": "#888",
      "activeSelection": "#c00",
      "interactive": {
        "secondary": {
          "default": "#888",
          "hover": "#333"
        }
      },
      "control": {
        "input": "#888",
        "secondary": "#888"
      },
      "container": {
        "default": "#d6d6d6",
        "active": "#888"
      },
      "separator": {
        "default": "#d6d6d6",
        "row": "#d6d6d6"
      },
      "disabled": "#d6d6d6",
      "warning": "#E86900",
      "success": "#008300"
    },
    "alert": {
      "warning": "#b85300",
      "success": "#008300"
    },
    "messaging": {
      "urgency": "#008300",
      "progress": "#008300",
      "shipping": "#b85300",
      "inStock": "#008300",
      "limitedStock": "#b85300",
      "promotion": "#c00",
      "clearance": "#Fde30b",
      "delivered": "#000",
      "canceled": "#000",
      "returned": "#000",
      "sent": "#000",
      "pickedup": "#000",
      "actionRequired": "#b85300",
      "disabled": "#666",
      "warning": "#b85300",
      "success": "#008300"
    },
    "registry": {
      "promoBackground": "#ead18b",
      "noteBackground": "#ead18b",
      "mostWanted": "#f7da5e",
      "baby": "#d7e26d",
      "wedding": "#a7dbd8",
      "college": "#f7da5e",
      "housewarming": "#f7da5e",
      "wishlist": "#568B30",
      "custom": "#a7dbd8"
    }
  },
  "font": {
    "family": {
      "sansSerif": "\"HelveticaForTarget\", \"Targetica\", \"HelveticaNeue for Target\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif"
    },
    "size": {
      "text": {
        "xsmall": "10px",
        "small": "12px",
        "medium": "14px",
        "base": "16px",
        "large": "19px",
        "xlarge": "23px",
        "xxlarge": "29px"
      },
      "input": {
        "base": "16px"
      },
      "body": {
        "small": "12px",
        "medium": "14px",
        "large": "16px"
      },
      "heading": {
        "level1": "29px",
        "level2": "23px",
        "level3": "19px",
        "level4": "16px"
      }
    },
    "weight": {
      "light": 300,
      "normal": 400,
      "bold": "bold",
      "input": {
        "text": 400
      }
    },
    "lineHeight": {
      "text": 1.4285,
      "heading": 1.25,
      "input": 1.25,
      "reset": 1
    }
  },
  "layering": {
    "shadow": null,
    "z-index": null,
    "overlay": {
      "modal": "rgba(51,51,51,0.8)"
    }
  },
  "space": {
    "generic": {
      "1x": "5px",
      "2x": "10px",
      "3x": "15px",
      "4x": "20px",
      "5x": "25px",
      "6x": "30px",
      "7x": "35px",
      "8x": "40px"
    },
    "inset": {
      "1x": "5px",
      "2x": "10px",
      "3x": "15px",
      "4x": "20px",
      "5x": "25px",
      "6x": "30px",
      "7x": "35px",
      "8x": "40px"
    },
    "insetSquish": {
      "1x": "6px 10px",
      "2x": "10px 15px",
      "3x": "12px 20px",
      "4x": "15px 25px",
      "5x": "18px 30px",
      "6x": "21px 35px"
    },
    "stack": {
      "1x": "0 0 5px",
      "2x": "0 0 10px",
      "3x": "0 0 15px",
      "4x": "0 0 20px",
      "5x": "0 0 25px",
      "6x": "0 0 30px",
      "7x": "0 0 35px",
      "8x": "0 0 40px"
    }
  }
};
